<template>
  <div class="list__wrapper">
    <div class="list__heading">
      <div class="d-flex flex-column" v-if="!hidden">
        <div class="d-flex align-center flex-col list__heading-title-wrapper">
          <div v-if="displayBackBtn" @click="backBtnHandler" class="go-back">
            <v-icon>mdi-chevron-left</v-icon>
          </div>
          <h1>{{ title }}</h1>
        </div>

        <p>{{ subTitle }}</p>
      </div>
      <div class="list__heading-actions">
        <slot name="actions"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: "ResourceListWrapper",
    props: {
      title: {
        type: String,
        default: "",
      },
      subTitle: {
        type: String,
        default: "",
      },
      hidden: {
        type: Boolean,
        default: false,
      },
      displayBackBtn: {
        type: Boolean,
        default: false,
      },
      backBtnHandler: {
        type: Function,
        default: () => {
          this.$router.back();
        },
      },
    },
  };
</script>
<style scoped lang="scss">
  @import "../../@core/preset/preset/typography/index.scss";
  @import "../../@core/preset/preset/functions";

  .list {
    &__wrapper {
      .go-back {
        margin-right: 15px;
        .v-icon {
          color: get-color("primary");
          height: 30px;
          width: 10px;
          font-size: 32px;
          cursor: pointer;
        }
      }
      .list__heading {
        display: flex;
        align-items: center;
        &-title-wrapper {
          margin-bottom: 6px;
        }
        h1 {
          @include heading-2();
          color: get-color("headline");
        }
        p {
          @include text-subtitle-1();
          color: get-color("subtitle");
          margin-bottom: 0;
        }

        &-actions {
          margin-left: auto;
        }
      }

      &::v-deep {
        .v-data-iterator {
          margin-top: 24px;
          border-radius: 6px;
          box-shadow: 0px 2px 10px rgba(69, 64, 78, 0.1) !important;
          overflow: hidden;
          .data-table-custom-class {
            padding-top: 0;
          }
          .v-toolbar__content {
            padding: 12px 16px;
          }
        }
      }
    }
  }
</style>
